import React, { FC } from 'react';
import { FactContainer, SummaryContainer } from './Summary.style';
import { IDicom, IStudy, IStudyLabelingJob } from 'models/icardio';

interface IProps {
  study: IStudy;
  studyLabelingJob?: IStudyLabelingJob;
  dicoms: IDicom[];
}

const Summary: FC<IProps> = props => {
  const { study, studyLabelingJob, dicoms } = props;
  return (
    <SummaryContainer>
      <FactContainer>
        <div>Number of dicoms:</div>
        <div>
          {dicoms?.length} of {study?.numberOfDicoms}
        </div>
      </FactContainer>
      <FactContainer>
        <div>Missing from study:</div>
        <div>
          {study?.numberOfDicoms - dicoms?.length} of {study?.numberOfDicoms}
        </div>
      </FactContainer>
      {studyLabelingJob && (
        <FactContainer>
          <div>Completed dicoms:</div>
          <div>
            {studyLabelingJob?.numberOfCompletedDicomLabelingJobs} of {dicoms?.length}
          </div>
        </FactContainer>
      )}
    </SummaryContainer>
  );
};

export default Summary;
